module.exports = __webpack_public_path__ + "static/media/honda.65d99e9b.jpg";